{
  "apply-job": {
    "en": "Job Application",
    "ar": "التقدم للوظيفة",
    "id": "Lamar Pekerjaan"
  },
  "application-progress": {
    "en": "Application Progress",
    "ar": "تقدم الطلب",
    "id": "Kemajuan Lamaran"
  },

  "hr-apply-job": {
    "en": "HR Job Application",
    "ar": "طلب وظيفة الموارد البشرية",
    "id": "Lamar Pekerjaan HR"
  },

  "already-applied": {
    "en": "You have already applied to this job.",
    "ar": "لقد تقدمت بالفعل لهذه الوظيفة.",
    "id": "Anda sudah melamar pekerjaan ini."
  },

  "video-section-title": {
    "en": "Want to Stand Out? Tell Us a Short Story",
    "ar": "هل تريد التميز؟ أخبرنا قصة قصيرة",
    "id": "Ingin Menonjol? Ceritakan Kisah Singkat"
  },
  "video-section-description": {
    "en": "This short video is optional, but candidates who share it usually stand out. It helps us understand how you think, solve problems, and communicate beyond what's written on paper.",
    "ar": "هذا الفيديو القصير اختياري، لكن المرشحين الذين يشاركونه عادةً ما يتميزون. يساعدنا على فهم طريقة تفكيرك وحل المشكلات والتواصل بما يتجاوز ما هو مكتوب على الورق.",
    "id": "Video singkat ini opsional, tetapi kandidat yang membagikannya biasanya lebih menonjol. Ini membantu kami memahami cara Anda berpikir, memecahkan masalah, dan berkomunikasi di luar apa yang tertulis di atas kertas."
  },
  "video-section-description2": {
    "en": "Please record your video in the primary language mentioned in the job description. If other languages are required, you may add short videos in those languages. One language per video.",
    "ar": "يرجى تسجيل الفيديو باللغة الأساسية المذكورة في وصف الوظيفة. إذا كانت هناك لغات أخرى مطلوبة، يمكنك إضافة فيديوهات قصيرة بتلك اللغات. لغة واحدة لكل فيديو.",
    "id": "Harap rekam video Anda dalam bahasa utama yang disebutkan dalam deskripsi pekerjaan. Jika bahasa lain diperlukan, Anda dapat menambahkan video pendek dalam bahasa tersebut. Satu bahasa per video."
  },
  "video-section-description3": {
    "en": "We evaluate all applications based on skills, experience, and professional thinking only. This video will not be used to assess personal characteristics unrelated to the role. Submitting a video is optional and it will be used solely for recruitment purposes, in accordance with data protection regulations.",
    "ar": "نقيّم جميع الطلبات بناءً على المهارات والخبرة والتفكير المهني فقط. لن يُستخدم هذا الفيديو لتقييم الخصائص الشخصية غير المتعلقة بالدور. تقديم الفيديو اختياري وسيُستخدم فقط لأغراض التوظيف، وفقاً للوائح حماية البيانات.",
    "id": "Kami mengevaluasi semua lamaran berdasarkan keterampilan, pengalaman, dan pemikiran profesional saja. Video ini tidak akan digunakan untuk menilai karakteristik pribadi yang tidak terkait dengan peran. Mengirimkan video bersifat opsional dan hanya akan digunakan untuk tujuan rekrutmen, sesuai dengan peraturan perlindungan data."
  },
  "add-video": {
    "en": "Add Video",
    "ar": "إضافة فيديو",
    "id": "Tambah Video"
  },
  "max-video": {
    "en": "([0] Sec max)",
    "ar": "([0] ثانية كحد أقصى)",
    "id": "([0] detik maks)"
  },
  "example-video": {
    "en": "Example video",
    "ar": "فيديو توضيحي",
    "id": "Contoh video"
  },
  "video-section-seconds": {
    "en": "[0] seconds",
    "ar": "[0] ثوانٍ",
    "id": "[0] detik"
  },
  "empty-currency": {
    "en": "Please select a currency",
    "ar": "يرجى اختيار العملة",
    "id": "Silakan pilih mata uang"
  },
  "salary-range-invalid": {
    "en": "Maximum salary must be greater than minimum salary",
    "ar": "يجب أن يكون الحد الأقصى للراتب أكبر من الحد الأدنى",
    "id": "Gaji maksimum harus lebih besar dari gaji minimum"
  },
  "complete-profile": {
    "en": "Complete your profile to showcase your qualifications",
    "ar": "أكمل ملفك الشخصي لعرض مؤهلاتك",
    "id": "Lengkapi profil Anda untuk menampilkan kualifikasi Anda"
  },
  "begin-application": {
    "en": "Start your application and showcase your qualifications",
    "ar": "ابدأ طلبك واعرض مؤهلاتك",
    "id": "Mulai lamaran Anda dan tunjukkan kualifikasi Anda"
  },
  "personal-details": {
    "en": "Personal Details",
    "ar": "البيانات الشخصية",
    "id": "Detail Pribadi"
  },
  "login": {
    "en": "Continue with existing account",
    "ar": "المتابعة بحساب موجود",
    "id": "Lanjutkan dengan akun yang ada"
  },
  "login2": {
    "en": "Login",
    "ar": "تسجيل الدخول",
    "id": "Login"
  },
  "personal-details-description": {
    "en": "Make sure your personal details are accurate",
    "ar": "تأكد من دقة بياناتك الشخصية",
    "id": "Pastikan detail pribadi Anda akurat"
  },
  "choose-language": {
    "en": "Choose your Language",
    "ar": "اختر لغتك",
    "id": "Pilih Bahasa Anda"
  },
  "select-language": {
    "en": "Select language",
    "ar": "اختر اللغة",
    "id": "Pilih bahasa"
  },
  "title": {
    "en": "Title",
    "ar": "اللقب",
    "id": "Gelar"
  },
  "first-name": {
    "en": "First Name",
    "ar": "الاسم الأول",
    "id": "Nama Depan"
  },
  "last-name": {
    "en": "Last Name",
    "ar": "اسم العائلة",
    "id": "Nama Belakang"
  },
  "first-name-placeholder": {
    "en": "Input your first name here",
    "ar": "أدخل اسمك الأول هنا",
    "id": "Masukkan nama depan Anda di sini"
  },
  "last-name-placeholder": {
    "en": "Input your last name here",
    "ar": "أدخل اسم عائلتك هنا",
    "id": "Masukkan nama belakang Anda di sini"
  },
  "country": {
    "en": "Country",
    "ar": "الدولة",
    "id": "Negara"
  },
  "select-country": {
    "en": "Select Country",
    "ar": "اختر الدولة",
    "id": "Pilih Negara"
  },
  "search-country": {
    "en": "Search country...",
    "ar": "ابحث عن الدولة...",
    "id": "Cari negara..."
  },
  "no-country-found": {
    "en": "No country found.",
    "ar": "لم يتم العثور على دولة.",
    "id": "Negara tidak ditemukan."
  },
  "email": {
    "en": "Email",
    "ar": "البريد الإلكتروني",
    "id": "Email"
  },
  "email-placeholder": {
    "en": "Ex: Mohamed@gmail.com",
    "ar": "مثال: Mohamed@gmail.com",
    "id": "Contoh: Mohamed@gmail.com"
  },
  "next": {
    "en": "Next",
    "ar": "التالي",
    "id": "Selanjutnya"
  },
  "back": {
    "en": "Back",
    "ar": "رجوع",
    "id": "Kembali"
  },
  "submitting": {
    "en": "Submitting...",
    "ar": "جاري الإرسال...",
    "id": "Mengirim..."
  },
  "saving": {
    "en": "Saving...",
    "ar": "جاري الحفظ...",
    "id": "Menyimpan..."
  },
  "experience": {
    "en": "Experience",
    "ar": "الخبرة",
    "id": "Pengalaman"
  },
  "step-1-of-5-experience": {
    "en": "Step 1 of 5: Experience",
    "ar": "الخطوة 1 من 5: الخبرة",
    "id": "Langkah 1 dari 5: Pengalaman"
  },
  "position": {
    "en": "Position",
    "ar": "المنصب",
    "id": "Posisi"
  },
  "position-placeholder": {
    "en": "Ex. Senior Developer",
    "ar": "مثال: مطور أول",
    "id": "Contoh: Developer Senior"
  },
  "search-position": {
    "en": "Search position...",
    "ar": "ابحث عن المنصب...",
    "id": "Cari posisi..."
  },
  "searching": {
    "en": "Searching...",
    "ar": "جاري البحث...",
    "id": "Mencari..."
  },
  "try-typing": {
    "en": "Try typing...",
    "ar": "حاول الكتابة...",
    "id": "Coba ketik..."
  },
  "no-position-found": {
    "en": "No position found.",
    "ar": "لم يتم العثور على منصب.",
    "id": "Posisi tidak ditemukan."
  },
  "highlight-top-experience": {
    "en": "Highlight your top experience",
    "ar": "أبرز أفضل خبراتك",
    "id": "Sorot pengalaman terbaik Anda"
  },
  "add-experience-1": {
    "en": "Add Experience 1",
    "ar": "إضافة الخبرة 1",
    "id": "Tambah Pengalaman 1"
  },
  "add-experience-2": {
    "en": "Add Experience 2",
    "ar": "إضافة الخبرة 2",
    "id": "Tambah Pengalaman 2"
  },
  "add-more-experience": {
    "en": "Add More Experience",
    "ar": "إضافة المزيد من الخبرات",
    "id": "Tambah Pengalaman Lainnya"
  },
  "education-skills-languages": {
    "en": "HR Job Application",
    "ar": "طلب وظيفة الموارد البشرية",
    "id": "Lamaran Pekerjaan HR"
  },
  "step-2-of-5-education": {
    "en": "Step 2 of 5: Education, Skills & Languages",
    "ar": "الخطوة 2 من 5: التعليم والمهارات واللغات",
    "id": "Langkah 2 dari 5: Pendidikan, Keahlian & Bahasa"
  },
  "add-videos": {
    "en": "Add Videos",
    "ar": "إضافة فيديوهات",
    "id": "Tambah Video"
  },
  "step-5-of-5-videos": {
    "en": "Step 5 of 5: Videos",
    "ar": "الخطوة 5 من 5: الفيديوهات",
    "id": "Langkah 5 dari 5: Video"
  },
  "get-noticed-faster": {
    "en": "Get Noticed Faster",
    "ar": "احصل على انتباه أسرع",
    "id": "Dapatkan Perhatian Lebih Cepat"
  },
  "add-intro-video": {
    "en": "Add a quick intro video to make you stand out from other candidates",
    "ar": "أضف فيديو تعريفي سريع لتتميز عن المرشحين الآخرين",
    "id": "Tambahkan video intro singkat untuk membuat Anda menonjol dari kandidat lain"
  },
  "next-step": {
    "en": "Next Step",
    "ar": "الخطوة التالية",
    "id": "Langkah Selanjutnya"
  },
  "submit-successfully": {
    "en": "Submit Successfully!",
    "ar": "تم الإرسال بنجاح!",
    "id": "Berhasil Dikirim!"
  },
  "congrats-submit": {
    "en": "Congrats! You have successfully submit your application",
    "ar": "مبروك! لقد قمت بإرسال طلبك بنجاح",
    "id": "Selamat! Anda telah berhasil mengirim lamaran Anda"
  },
  "congrats-submitted": {
    "en": "Congrats! You have successfully submitted your application",
    "ar": "مبروك! لقد قمت بإرسال طلبك بنجاح",
    "id": "Selamat! Anda telah berhasil mengirim lamaran Anda"
  },
  "ok-got-it": {
    "en": "Ok, got it!",
    "ar": "حسناً، فهمت!",
    "id": "Ok, mengerti!"
  },
  "make-sure-suit-task": {
    "en": "Make sure your suit for the task",
    "ar": "تأكد من ملاءمتك للمهمة",
    "id": "Pastikan Anda cocok untuk tugas tersebut"
  },
  "seconds-video": {
    "en": "seconds video",
    "ar": "ثواني فيديو",
    "id": "detik video"
  },
  "uploaded": {
    "en": "Uploaded",
    "ar": "تم الرفع",
    "id": "Diunggah"
  },
  "projects": {
    "en": "Projects",
    "ar": "المشاريع",
    "id": "Proyek"
  },
  "step-4-of-5-projects": {
    "en": "Step 4 of 5: Projects",
    "ar": "الخطوة 4 من 5: المشاريع",
    "id": "Langkah 4 dari 5: Proyek"
  },
  "show-your-projects": {
    "en": "Show Your Projects",
    "ar": "أظهر مشاريعك",
    "id": "Tunjukkan Proyek Anda"
  },
  "share-real-projects": {
    "en": "Share real projects you have worked on",
    "ar": "شارك مشاريع حقيقية عملت عليها",
    "id": "Bagikan proyek nyata yang telah Anda kerjakan"
  },
  "upload-images-video-instructions-1": {
    "en": "Upload Images And A Short Video",
    "ar": "قم برفع صور وفيديو قصير",
    "id": "Unggah Gambar Dan Video Singkat"
  },
  "upload-images-video-instructions-2": {
    "en": "To Present Your Project. Explain What You Built, Your Role, And The Result.",
    "ar": "لعرض مشروعك. اشرح ما بنيته ودورك والنتيجة.",
    "id": "Untuk Mempresentasikan Proyek Anda. Jelaskan Apa Yang Anda Buat, Peran Anda, Dan Hasilnya."
  },
  "max-40-seconds": {
    "en": "Max 40 Seconds",
    "ar": "بحد أقصى 40 ثانية",
    "id": "Maks 40 Detik"
  },
  "project-images-videos": {
    "en": "Project Images / Videos",
    "ar": "صور / فيديوهات المشروع",
    "id": "Gambar / Video Proyek"
  },
  "upload-images-videos": {
    "en": "Upload images / Videos",
    "ar": "رفع الصور / الفيديوهات",
    "id": "Unggah gambar / Video"
  },
  "upload-files": {
    "en": "Upload files",
    "ar": "رفع الملفات",
    "id": "Unggah file"
  },
  "project-info-1": {
    "en": "Sharing a project **helps us better understand** your experience and professional skills.",
    "ar": "مشاركة مشروع **يساعدنا على فهم** خبرتك ومهاراتك المهنية بشكل أفضل.",
    "id": "Membagikan proyek **membantu kami lebih memahami** pengalaman dan keterampilan profesional Anda."
  },
  "project-info-2": {
    "en": "All uploaded content is kept **private** and will be used only for **internal professional evaluation purposes**.",
    "ar": "جميع المحتويات المرفوعة تبقى **خاصة** وستستخدم فقط **لأغراض التقييم المهني الداخلي**.",
    "id": "Semua konten yang diunggah dijaga **kerahasiaannya** dan hanya akan digunakan untuk **tujuan evaluasi profesional internal**."
  },
  "project-info-3": {
    "en": "By uploading content, you confirm that you have the right to share it and that it **does not include confidential or proprietary information belonging to others**.",
    "ar": "برفع المحتوى، تؤكد أن لديك الحق في مشاركته وأنه **لا يتضمن معلومات سرية أو ملكية تخص الآخرين**.",
    "id": "Dengan mengunggah konten, Anda mengonfirmasi bahwa Anda memiliki hak untuk membagikannya dan bahwa konten tersebut **tidak berisi informasi rahasia atau hak milik pihak lain**."
  },
  "project-images": {
    "en": "Project Images",
    "ar": "صور المشروع",
    "id": "Gambar Proyek"
  },
  "one-or-more": {
    "en": "(One or more)",
    "ar": "(واحدة أو أكثر)",
    "id": "(Satu atau lebih)"
  },
  "upload-images": {
    "en": "Upload images",
    "ar": "رفع الصور",
    "id": "Unggah gambar"
  },
  "project-video": {
    "en": "Project Video",
    "ar": "فيديو المشروع",
    "id": "Video Proyek"
  },
  "upload-video": {
    "en": "Add Video",
    "ar": "إضافة فيديو",
    "id": "Tambah Video"
  },
  "upload-video-max-40": {
    "en": "Upload Video (max 40 seconds)",
    "ar": "رفع فيديو (بحد أقصى 40 ثانية)",
    "id": "Unggah Video (maks 40 detik)"
  },
  "project-file": {
    "en": "Project File",
    "ar": "ملف المشروع",
    "id": "File Proyek"
  },
  "upload-file-types": {
    "en": "Upload a file ex: pdf or word",
    "ar": "قم بتحميل ملف، على سبيل المثال: ملف PDF أو Word",
    "id": "Unggah file contoh: pdf or word"
  },
  "project-description": {
    "en": "Project Description",
    "ar": "وصف المشروع",
    "id": "Deskripsi Proyek"
  },
  "project-description-helper": {
    "en": "Write a short summary of the project, tools used, and final outcome",
    "ar": "اكتب ملخصاً قصيراً للمشروع والأدوات المستخدمة والنتيجة النهائية",
    "id": "Tulis ringkasan singkat proyek, alat yang digunakan, dan hasil akhir"
  },
  "type-here": {
    "en": "Type here ...",
    "ar": "اكتب هنا ...",
    "id": "Ketik di sini ..."
  },
  "expected-salary": {
    "en": "Expected Salary",
    "ar": "الراتب المتوقع",
    "id": "Gaji yang Diharapkan"
  },
  "expected-salary-subtitle": {
    "en": "Tell us the monthly salary you expect for this role",
    "ar": "أخبرنا بالراتب الشهري الذي تتوقعه لهذا الدور",
    "id": "Beritahu kami gaji bulanan yang Anda harapkan untuk posisi ini"
  },
  "step-5-of-5-salary": {
    "en": "Step 5 of 5: Salary",
    "ar": "الخطوة 5 من 5: الراتب",
    "id": "Langkah 5 dari 5: Gaji"
  },
  "hr-job-application": {
    "en": "HR Job Application",
    "ar": "طلب وظيفة الموارد البشرية",
    "id": "Lamaran Pekerjaan HR"
  },
  "currency": {
    "en": "Currency",
    "ar": "العملة",
    "id": "Mata Uang"
  },
  "select-currency": {
    "en": "Select currency",
    "ar": "اختر العملة",
    "id": "Pilih mata uang"
  },
  "search-currency": {
    "en": "Search currency...",
    "ar": "ابحث عن العملة...",
    "id": "Cari mata uang..."
  },
  "no-currency-found": {
    "en": "No currency found",
    "ar": "لم يتم العثور على عملة",
    "id": "Mata uang tidak ditemukan"
  },
  "current-salary": {
    "en": "Current Salary",
    "ar": "الراتب الحالي",
    "id": "Gaji Saat Ini"
  },
  "expected-monthly-salary": {
    "en": "Monthly Salary",
    "ar": "الراتب الشهري",
    "id": "Gaji Bulanan"
  },
  "monthly-salary-from": {
    "en": "Monthly Salary (From)",
    "ar": "الراتب الشهري (من)",
    "id": "Gaji Bulanan (Dari)"
  },
  "monthly-salary-to": {
    "en": "Monthly Salary (To)",
    "ar": "الراتب الشهري (إلى)",
    "id": "Gaji Bulanan (Sampai)"
  },
  "probation-salary": {
    "en": "Probation Period Salary",
    "ar": "راتب فترة التجربة",
    "id": "Gaji Masa Percobaan"
  },
  "cover-letter": {
    "en": "Comment",
    "ar": "تعليق",
    "id": "Komentar"
  },
  "write-cover-letter": {
    "en": "Write your comment...",
    "ar": "اكتب تعليقك...",
    "id": "Tulis komentar Anda..."
  },
  "review": {
    "en": "Review",
    "ar": "مراجعة",
    "id": "Tinjau"
  },
  "edit": {
    "en": "Edit",
    "ar": "تعديل",
    "id": "Edit"
  },
  "full-name": {
    "en": "Full Name",
    "ar": "الاسم الكامل",
    "id": "Nama Lengkap"
  },
  "phone-number": {
    "en": "Phone Number",
    "ar": "رقم الهاتف",
    "id": "Nomor Telepon"
  },
  "no-personal-details": {
    "en": "No personal details available",
    "ar": "لا توجد بيانات شخصية متاحة",
    "id": "Tidak ada detail pribadi tersedia"
  },
  "experiences": {
    "en": "Experiences",
    "ar": "الخبرات",
    "id": "Pengalaman"
  },
  "no-experiences": {
    "en": "No experiences available",
    "ar": "لا توجد خبرات متاحة",
    "id": "Tidak ada pengalaman tersedia"
  },
  "language": {
    "en": "Language",
    "ar": "اللغة",
    "id": "Bahasa"
  },
  "no-languages": {
    "en": "No languages available",
    "ar": "لا توجد لغات متاحة",
    "id": "Tidak ada bahasa tersedia"
  },
  "educations": {
    "en": "Educations",
    "ar": "التعليم",
    "id": "Pendidikan"
  },
  "no-education": {
    "en": "No education available",
    "ar": "لا يوجد تعليم متاح",
    "id": "Tidak ada pendidikan tersedia"
  },
  "skills": {
    "en": "Skills",
    "ar": "المهارات",
    "id": "Keahlian"
  },
  "no-skills": {
    "en": "No skills available",
    "ar": "لا توجد مهارات متاحة",
    "id": "Tidak ada keahlian tersedia"
  },
  "videos": {
    "en": "Videos",
    "ar": "الفيديوهات",
    "id": "Video"
  },
  "no-videos": {
    "en": "No videos uploaded",
    "ar": "لم يتم رفع فيديوهات",
    "id": "Tidak ada video yang diunggah"
  },
  "submit-application": {
    "en": "Submit Application",
    "ar": "إرسال الطلب",
    "id": "Kirim Lamaran"
  },
  "verify-email": {
    "en": "Verification Code",
    "ar": "رمز التحقق",
    "id": "Kode Verifikasi"
  },
  "verification-code-sent": {
    "en": "Enter the 6-digit code sent to your email to verify your account",
    "ar": "أدخل الرمز المكون من 6 أرقام المرسل إلى بريدك الإلكتروني للتحقق من حسابك",
    "id": "Masukkan kode 6 digit yang dikirim ke email Anda untuk memverifikasi akun Anda"
  },
  "enter-6-digit-code": {
    "en": "A code has been sent to: [0]",
    "ar": "تم إرسال الرمز إلى: [0]",
    "id": "Kode telah dikirim ke: [0]"
  },
  "resend-code": {
    "en": "Resend",
    "ar": "إعادة الإرسال",
    "id": "Kirim Ulang"
  },
  "resending": {
    "en": "Resending...",
    "ar": "جاري إعادة الإرسال...",
    "id": "Mengirim ulang..."
  },
  "resend-code-in": {
    "en": "Resend code in",
    "ar": "إعادة إرسال الرمز في",
    "id": "Kirim ulang kode dalam"
  },
  "verify": {
    "en": "Verify",
    "ar": "تحقق",
    "id": "Verifikasi"
  },
  "verifying": {
    "en": "Verifying...",
    "ar": "جاري التحقق...",
    "id": "Memverifikasi..."
  },
  "present": {
    "en": "Present",
    "ar": "الحالي",
    "id": "Sekarang"
  },
  "to": {
    "en": "to",
    "ar": "إلى",
    "id": "hingga"
  },
  "validation-language-required": {
    "en": "Language is required",
    "ar": "اللغة مطلوبة",
    "id": "Bahasa wajib diisi"
  },
  "validation-title-required": {
    "en": "Title is required",
    "ar": "اللقب مطلوب",
    "id": "Gelar wajib diisi"
  },
  "validation-firstname-min": {
    "en": "First name must be at least 2 characters",
    "ar": "يجب أن يكون الاسم الأول على الأقل حرفين",
    "id": "Nama depan minimal 2 karakter"
  },
  "validation-firstname-max": {
    "en": "First name cannot exceed 100 characters",
    "ar": "لا يمكن أن يتجاوز الاسم الأول 100 حرف",
    "id": "Nama depan tidak boleh lebih dari 100 karakter"
  },
  "validation-lastname-min": {
    "en": "Last name must be at least 2 characters",
    "ar": "يجب أن يكون اسم العائلة على الأقل حرفين",
    "id": "Nama belakang minimal 2 karakter"
  },
  "validation-lastname-max": {
    "en": "Last name cannot exceed 100 characters",
    "ar": "لا يمكن أن يتجاوز اسم العائلة 100 حرف",
    "id": "Nama belakang tidak boleh lebih dari 100 karakter"
  },
  "validation-country-required": {
    "en": "Country is required",
    "ar": "الدولة مطلوبة",
    "id": "Negara wajib diisi"
  },
  "validation-email-invalid": {
    "en": "Invalid email format",
    "ar": "صيغة البريد الإلكتروني غير صالحة",
    "id": "Format email tidak valid"
  },
  "validation-email-required": {
    "en": "Email is required",
    "ar": "البريد الإلكتروني مطلوب",
    "id": "Email wajib diisi"
  },
  "validation-email-max": {
    "en": "Email cannot exceed 100 characters",
    "ar": "لا يمكن أن يتجاوز البريد الإلكتروني 100 حرف",
    "id": "Email tidak boleh lebih dari 100 karakter"
  },
  "validation-phonecode-required": {
    "en": "Country code is required",
    "ar": "رمز الدولة مطلوب",
    "id": "Kode negara wajib diisi"
  },
  "validation-phone-min": {
    "en": "Phone number must be at least 5 digits",
    "ar": "يجب أن يكون رقم الهاتف على الأقل 5 أرقام",
    "id": "Nomor telepon minimal 5 digit"
  },
  "validation-phone-max": {
    "en": "Phone number cannot exceed 15 digits",
    "ar": "لا يمكن أن يتجاوز رقم الهاتف 15 رقم",
    "id": "Nomor telepon tidak boleh lebih dari 15 digit"
  },
  "validation-phone-digits-only": {
    "en": "Phone number must contain only digits and spaces",
    "ar": "يجب أن يحتوي رقم الهاتف على أرقام ومسافات فقط",
    "id": "Nomor telepon hanya boleh berisi angka dan spasi"
  },
  "please-verify-email": {
    "en": "Please verify your email to continue",
    "ar": "يرجى التحقق من بريدك الإلكتروني للمتابعة",
    "id": "Silakan verifikasi email Anda untuk melanjutkan"
  },
  "application-submitted-success": {
    "en": "Application submitted successfully!",
    "ar": "تم إرسال الطلب بنجاح!",
    "id": "Lamaran berhasil dikirim!"
  },
  "unexpected-error": {
    "en": "An unexpected error occurred. Please try again.",
    "ar": "حدث خطأ غير متوقع. يرجى المحاولة مرة أخرى.",
    "id": "Terjadi kesalahan. Silakan coba lagi."
  },
  "edit-photo": {
    "en": "Change",
    "ar": "تغيير",
    "id": "Ubah"
  },
  "add-description": {
    "en": "Add Description",
    "ar": "إضافة وصف",
    "id": "Tambah Deskripsi"
  },
  "character-max": {
    "en": "200 Character Max",
    "ar": "200 حرف كحد أقصى",
    "id": "Maks 200 Karakter"
  },
  "cancel": {
    "en": "Cancel",
    "ar": "إلغاء",
    "id": "Batal"
  },
  "upload": {
    "en": "Upload",
    "ar": "رفع",
    "id": "Unggah"
  },
  "from": {
    "en": "From",
    "ar": "من",
    "id": "Dari"
  },
  "comment-optional": {
    "en": "Comment (optional)",
    "ar": "تعليق (اختياري)",
    "id": "Komentar (opsional)"
  },
  "increase-chances": {
    "en": "Increase your chances of being discovered by other relevant companies on our platform.",
    "ar": "زِد فرصك في أن تكتشفك شركات أخرى ذات صلة على منصتنا.",
    "id": "Tingkatkan peluang Anda untuk ditemukan oleh perusahaan lain yang relevan di platform kami."
  },
  "agree-share-profile": {
    "en": "I agree to have my profile and CV shared with other companies on the platform for suitable job opportunities.",
    "ar": "أوافق على مشاركة ملفي الشخصي وسيرتي الذاتية مع شركات أخرى على المنصة للحصول على فرص عمل مناسبة.",
    "id": "Saya setuju untuk membagikan profil dan CV saya dengan perusahaan lain di platform untuk peluang kerja yang sesuai."
  },
  "data-recruitment-only": {
    "en": "Your data will only be used for recruitment purposes and shared with trusted companies.",
    "ar": "سيتم استخدام بياناتك فقط لأغراض التوظيف ومشاركتها مع شركات موثوقة.",
    "id": "Data Anda hanya akan digunakan untuk tujuan rekrutmen dan dibagikan dengan perusahaan terpercaya."
  },
  "share-profile-required": {
    "en": "Please select whether you agree or disagree to share your profile with other companies.",
    "ar": "يرجى تحديد ما إذا كنت توافق أو لا توافق على مشاركة ملفك الشخصي مع شركات أخرى.",
    "id": "Silakan pilih apakah Anda setuju atau tidak setuju untuk membagikan profil Anda dengan perusahaan lain."
  },
  "project-photos-videos": {
    "en": "Project Photos / Videos",
    "ar": "صور / فيديوهات المشروع",
    "id": "Foto / Video Proyek"
  },
  "project-files": {
    "en": "Project Files",
    "ar": "ملفات المشروع",
    "id": "File Proyek"
  },
  "no-project-media": {
    "en": "No project photos or videos uploaded",
    "ar": "لم يتم رفع صور أو فيديوهات للمشروع",
    "id": "Tidak ada foto atau video proyek yang diunggah"
  },
  "no-project-files": {
    "en": "No project files uploaded",
    "ar": "لم يتم رفع ملفات المشروع",
    "id": "Tidak ada file proyek yang diunggah"
  },
  "salary-range": {
    "en": "Salary Range",
    "ar": "نطاق الراتب",
    "id": "Rentang Gaji"
  },
  "no-salary-info": {
    "en": "No salary information provided",
    "ar": "لم يتم تقديم معلومات الراتب",
    "id": "Tidak ada informasi gaji yang diberikan"
  },
  "i-agree": {
    "en": "I agree",
    "ar": "أوافق",
    "id": "Saya setuju"
  },
  "i-disagree": {
    "en": "I disagree",
    "ar": "لا أوافق",
    "id": "Saya tidak setuju"
  },
  "uploading-file": {
    "en": "Uploading [0]...",
    "ar": "جاري رفع [0]...",
    "id": "Mengunggah [0]..."
  },
  "file-uploaded-success": {
    "en": "[0] uploaded successfully",
    "ar": "تم رفع [0] بنجاح",
    "id": "[0] berhasil diunggah"
  },
  "file-upload-failed": {
    "en": "Failed to upload [0]",
    "ar": "فشل رفع [0]",
    "id": "Gagal mengunggah [0]"
  },
  "deleting-image": {
    "en": "Deleting image...",
    "ar": "جاري حذف الصورة...",
    "id": "Menghapus gambar..."
  },
  "image-deleted-success": {
    "en": "Image deleted successfully",
    "ar": "تم حذف الصورة بنجاح",
    "id": "Gambar berhasil dihapus"
  },
  "image-delete-failed": {
    "en": "Failed to delete image",
    "ar": "فشل حذف الصورة",
    "id": "Gagal menghapus gambar"
  },
  "deleting-video": {
    "en": "Deleting video...",
    "ar": "جاري حذف الفيديو...",
    "id": "Menghapus video..."
  },
  "video-deleted-success": {
    "en": "Video deleted successfully",
    "ar": "تم حذف الفيديو بنجاح",
    "id": "Video berhasil dihapus"
  },
  "video-delete-failed": {
    "en": "Failed to delete video",
    "ar": "فشل حذف الفيديو",
    "id": "Gagal menghapus video"
  },
  "deleting-document": {
    "en": "Deleting document...",
    "ar": "جاري حذف المستند...",
    "id": "Menghapus dokumen..."
  },
  "document-deleted-success": {
    "en": "Document deleted successfully",
    "ar": "تم حذف المستند بنجاح",
    "id": "Dokumen berhasil dihapus"
  },
  "document-delete-failed": {
    "en": "Failed to delete document",
    "ar": "فشل حذف المستند",
    "id": "Gagal menghapus dokumen"
  },
  "video-duration-error": {
    "en": "Video duration must be 40 seconds or less",
    "ar": "يجب ألا تتجاوز مدة الفيديو 40 ثانية",
    "id": "Durasi video harus 40 detik atau kurang"
  },
  "video-load-failed": {
    "en": "Failed to load video",
    "ar": "فشل تحميل الفيديو",
    "id": "Gagal memuat video"
  },
  "image": {
    "en": "image",
    "ar": "صورة",
    "id": "gambar"
  },
  "video": {
    "en": "video",
    "ar": "فيديو",
    "id": "video"
  },
  "document": {
    "en": "document",
    "ar": "مستند",
    "id": "dokumen"
  },
  "welcome-back": {
    "en": "Welcome back",
    "ar": "مرحباً بعودتك",
    "id": "Selamat datang kembali"
  },
  "continue-application": {
    "en": "Continue Application",
    "ar": "متابعة الطلب",
    "id": "Lanjutkan Lamaran"
  },
  "view-all-media": {
    "en": "All Media",
    "ar": "جميع الوسائط",
    "id": "Semua Media"
  },
  "view-all-documents": {
    "en": "All Documents",
    "ar": "جميع المستندات",
    "id": "Semua Dokumen"
  },
  "close": {
    "en": "Close",
    "ar": "إغلاق",
    "id": "Tutup"
  },
  "step-require-experience": {
    "en": "Add at least one work experience to continue.",
    "ar": "أضف خبرة عمل واحدة على الأقل للمتابعة.",
    "id": "Tambahkan setidaknya satu pengalaman kerja untuk melanjutkan."
  },
  "step-require-education-skills-language": {
    "en": "Add at least one education entry, one skill, and one language to continue.",
    "ar": "أضف تعليماً واحداً على الأقل، ومهارة واحدة، ولغة واحدة للمتابعة.",
    "id": "Tambahkan setidaknya satu pendidikan, satu keterampilan, dan satu bahasa untuk melanjutkan."
  },
  "step-require-videos": {
    "en": "Complete all required video uploads to continue.",
    "ar": "أكمل رفع جميع الفيديوهات المطلوبة للمتابعة.",
    "id": "Selesaikan semua unggahan video yang wajib untuk melanjutkan."
  },
  "step-require-project-files": {
    "en": "Upload at least one image, video, or document to continue.",
    "ar": "ارفع صورة أو فيديو أو مستنداً واحداً على الأقل للمتابعة.",
    "id": "Unggah setidaknya satu gambar, video, atau dokumen untuk melanjutkan."
  },
  "step-require-salary": {
    "en": "Complete currency, salary range, and profile sharing choice to continue.",
    "ar": "أكمل العملة ونطاق الراتب وخيار مشاركة الملف للمتابعة.",
    "id": "Lengkapi mata uang, rentang gaji, dan pilihan berbagi profil untuk melanjutkan."
  }
}
